// import axios from "@/axiosInterceptor";

const state = () => ({
  Classifications: true,
  Identity: true,
  Operations: true,
  Lanes: true,
  Certifications: true,
  Insurance: true,
  InsuranceExclusions: true,
  Payment: true,
  Questions: true,
  Integrations: true,
  Contract: true,
  isPreset: {
    Classifications: false,
    Identity: false,
    Operations: false,
    Lanes: false,
    Certifications: false,
    Insurance: false,
    InsuranceExclusions: false,
    Payment: false,
    Questions: false,
    Integrations: false,
    Contract: false,
  },
});

// getters

const getters = {};

// actions

const actions = {};

//mutations
const mutations = {
  updateInitialFirstTime(state, data) {
    for (const [key, value] of Object.entries(data)) {
      if (state.isPreset[key] === false) {
        state[key] = value;
        state.isPreset[key] = true;
      } else {
        // console.log(
        //   'UPDATE INITIAL | VUEX | firstTime.js: ' +
        //     key +
        //     ' is already set to ' +
        //     state[key]
        // );
      }
    }
  },
  updateStepFirstTime(state, { step, value }) {
    state[step] = value;
    if (state.isPreset[step] === false) {
      state.isPreset[step] = true;
    }
    // console.log(
    //   'UPDATE FIRST TIME | VUEX | firstTime.js: ' + step + ' set to ' + value
    // );
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
